
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AttachmentsModal from '../AttachmentsModal/AttachmentsModal';
import moment from 'moment';
import './Students.css';

const Student = () => {
  const [students, setStudents] = useState([]);
  const [statusFilter, setStatusFilter] = useState('');
  const [registrationStatusFilter, setRegistrationStatusFilter] = useState('');
  const [courseFilter, setCourseFilter] = useState(''); // New filter for courses
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    async function getCourses() {
      try {
        const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
        if (response) {
          console.log('students', response);
          setStudents(response.data);
        } else {
          console.log('pull fail');
        }
      } catch (e) {
        console.log('catch error', e);
      }
    }
    getCourses();
  }, []);

  const fetchAttachments = async (userId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASEURL}/images`, {
        params: { UserID: userId }
      });
      if (response) {
        console.log('pulled', response);
        setSelectedFiles(response.data);
        setIsModalOpen(true);
      } else {
        console.log('pull fail');
      }
    } catch (e) {
      console.log('catch error', e);
    }
  };

  const handleStatusChange = async (index, student, newStatus) => {
    const confirmed = window.confirm(`Do you want to update the status to ${newStatus}?`);
    if (confirmed) {
      setLoading(true);
      const updatedStudents = [...students];
      updatedStudents[index].ReviewStatus = newStatus;
      try {
        await axios.post(process.env.REACT_APP_BASEURL + '/api/application/update', {
          User_ID: student.User_ID,
          IndexID: student.IndexID,
          ReviewStatus: newStatus,
          FirstName: student.FirstName,
          CourseName: student.CourseName,
          Cost: student.Cost,
          Email: student?.Email,
          StartDate: student?.StartDate,
        });
        setStudents(updatedStudents);
      } catch (error) {
        alert(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleRegistrationStatusFilterChange = (e) => {
    setRegistrationStatusFilter(e.target.value); // Handle the new filter change
  };

  const handleCourseFilterChange = (e) => {
    setCourseFilter(e.target.value); // Handle the course filter change
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({ ...prev, [name]: value }));
  };

  // Extract unique courses for the dropdown
  const uniqueCourses = [...new Set(students.map(student => student.CourseName))];

  const filteredStudents = students
    .filter((student) => {
      const statusMatch = statusFilter ? student.ReviewStatus === statusFilter : true;
      const registrationStatusMatch = registrationStatusFilter
        ? student.Status === registrationStatusFilter
        : true;
      const courseMatch = courseFilter ? student.CourseName === courseFilter : true; // New filter for courses
      const dateMatch =
        (!dateRange.start || new Date(student.CreationDate) >= new Date(dateRange.start)) &&
        (!dateRange.end || new Date(student.CreationDate) <= new Date(dateRange.end));
      return statusMatch && registrationStatusMatch && courseMatch && dateMatch; // Include new filter condition
    })
    .sort((a, b) => new Date(b.CreationDate) - new Date(a.CreationDate));

  return (
    <div className="studentContainer">
      <div className="header">
        <h2>Student List</h2>
        <div className="filters">
          {/* New filter for registration status */}
          <select value={registrationStatusFilter} onChange={handleRegistrationStatusFilterChange} className="filterDropdown">
            <option value="">All Registration Status</option>
            <option value="Registered">Registered</option>
            <option value="Pending">Pending</option>
          </select>

          {/* New filter for courses */}
          <select value={courseFilter} onChange={handleCourseFilterChange} className="filterDropdown">
            <option value="">All Courses</option>
            {uniqueCourses.map((course, index) => (
              <option key={index} value={course}>{course}</option>
            ))}
          </select>
          
          <select value={statusFilter} onChange={handleStatusFilterChange} className="filterDropdown">
            <option value="">All Statuses</option>
            <option value="Pending">Pending</option>
            <option value="Accepted">Accepted</option>
            <option value="Rejected">Rejected</option>
          </select>
          <input
            type="date"
            name="start"
            value={dateRange.start}
            onChange={handleDateChange}
            className="filterDate"
          />
          <input
            type="date"
            name="end"
            value={dateRange.end}
            onChange={handleDateChange}
            className="filterDate"
          />
        </div>
      </div>
      {loading && <p>Loading...</p>}
      <table className="studentTable">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>StudentID</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Registration</th>
            <th>Course</th>
            <th>Applied</th>
            <th>Attachments</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudents.map((student, index) => (
            <tr key={student.IndexID}>
              <td>{student.FirstName}</td>
              <td>{student.LastName}</td>
              <td>{student.User_ID}</td>
              <td>{student.Phone}</td>
              <td>{student.Email}</td>
              <td>{student?.Status}</td>
              <td>{student.CourseName}</td>
              <td>{moment(student?.CreationDate).format('YYYY-MM-DD')}</td>
              <td>
                <button onClick={() => fetchAttachments(student.User_ID)}>
                  View Attachments
                </button>
              </td>
              <td>
                <select
                  defaultValue={student.ReviewStatus}
                  onChange={(e) => handleStatusChange(index, student, e.target.value)}
                  className="statusDropdown"
                >
                  <option value="Pending">Pending</option>
                  <option value="Accepted">Accepted</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <AttachmentsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        files={selectedFiles}
      />
    </div>
  );
};

export default Student;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import AttachmentsModal from '../AttachmentsModal/AttachmentsModal';
// import moment from 'moment';
// import './Students.css';

// const Student = () => {
//   const [students, setStudents] = useState([]);
//   const [statusFilter, setStatusFilter] = useState('');
//   const [registrationStatusFilter, setRegistrationStatusFilter] = useState(''); // New filter
//   const [dateRange, setDateRange] = useState({ start: '', end: '' });
//   const [loading, setLoading] = useState(false);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     async function getCourses() {
//       try {
//         const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
//         if (response) {
//           console.log('students', response);
//           setStudents(response.data);
//         } else {
//           console.log('pull fail');
//         }
//       } catch (e) {
//         console.log('catch error', e);
//       }
//     }
//     getCourses();
//   }, []);

//   const fetchAttachments = async (userId) => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_BASEURL}/images`, {
//         params: { UserID: userId }
//       });
//       if (response) {
//         console.log('pulled', response);
//         setSelectedFiles(response.data);
//         setIsModalOpen(true);
//       } else {
//         console.log('pull fail');
//       }
//     } catch (e) {
//       console.log('catch error', e);
//     }
//   };

//   const handleStatusChange = async (index, student, newStatus) => {
//     const confirmed = window.confirm(`Do you want to update the status to ${newStatus}?`);
//     if (confirmed) {
//       setLoading(true);
//       const updatedStudents = [...students];
//       updatedStudents[index].ReviewStatus = newStatus;
//       try {
//         await axios.post(process.env.REACT_APP_BASEURL + '/api/application/update', {
//           User_ID: student.User_ID,
//           IndexID: student.IndexID,
//           ReviewStatus: newStatus,
//           FirstName: student.FirstName,
//           CourseName: student.CourseName,
//           Cost: student.Cost,
//           Email: student?.Email,
//           StartDate: student?.StartDate,
//         });
//         setStudents(updatedStudents);
//       } catch (error) {
//         alert(error.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleStatusFilterChange = (e) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleRegistrationStatusFilterChange = (e) => {
//     setRegistrationStatusFilter(e.target.value); // Handle the new filter change
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange((prev) => ({ ...prev, [name]: value }));
//   };

//   const filteredStudents = students
//     .filter((student) => {
//       const statusMatch = statusFilter ? student.ReviewStatus === statusFilter : true;
//       const registrationStatusMatch = registrationStatusFilter
//         ? student.Status === registrationStatusFilter
//         : true; // Filter by registration status
//       const dateMatch =
//         (!dateRange.start || new Date(student.CreationDate) >= new Date(dateRange.start)) &&
//         (!dateRange.end || new Date(student.CreationDate) <= new Date(dateRange.end));
//       return statusMatch && registrationStatusMatch && dateMatch; // Include new filter condition
//     })
//     .sort((a, b) => new Date(b.CreationDate) - new Date(a.CreationDate)); // Sort dates in descending order

//   return (
//     <div className="studentContainer">
//       <div className="header">
//         <h2>Student List</h2>
//         <div className="filters">
//           {/* New filter for registration status */}
//           <select value={registrationStatusFilter} onChange={handleRegistrationStatusFilterChange} className="filterDropdown">
//             <option value="">All Registration Status</option>
//             <option value="Registered">Registered</option>
//             <option value="Pending">Pending</option>
//           </select>
          
//           <select value={statusFilter} onChange={handleStatusFilterChange} className="filterDropdown">
//             <option value="">All Statuses</option>
//             <option value="Pending">Pending</option>
//             <option value="Accepted">Accepted</option>
//             <option value="Rejected">Rejected</option>
//           </select>
//           <input
//             type="date"
//             name="start"
//             value={dateRange.start}
//             onChange={handleDateChange}
//             className="filterDate"
//           />
//           <input
//             type="date"
//             name="end"
//             value={dateRange.end}
//             onChange={handleDateChange}
//             className="filterDate"
//           />
//         </div>
//       </div>
//       {loading && <p>Loading...</p>}
//       <table className="studentTable">
//         <thead>
//           <tr>
//             <th>First Name</th>
//             <th>Last Name</th>
//             <th>Phone</th>
//             <th>Email</th>
//             <th>Registration</th>
//             <th>Course</th>
//             <th>Applied</th>
//             <th>Attachments</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredStudents.map((student, index) => (
//             <tr key={student.IndexID}>
//               <td>{student.FirstName}</td>
//               <td>{student.LastName}</td>
//               <td>{student.Phone}</td>
//               <td>{student.Email}</td>
//               <td>{student?.Status}</td>
//               <td>{student.CourseName}</td>
//               <td>{moment(student?.CreationDate).format('YYYY-MM-DD')}</td>
//               <td>
//                 <button onClick={() => fetchAttachments(student.User_ID)}>
//                   View Attachments
//                 </button>
//               </td>
//               <td>
//                 <select
//                   defaultValue={student.ReviewStatus}
//                   onChange={(e) => handleStatusChange(index, student, e.target.value)}
//                   className="statusDropdown"
//                 >
//                   <option value="Pending">Pending</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="Rejected">Rejected</option>
//                 </select>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <AttachmentsModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         files={selectedFiles}
//       />
//     </div>
//   );
// };

// export default Student;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import AttachmentsModal from '../AttachmentsModal/AttachmentsModal';
// import moment from 'moment';
// import './Students.css';

// const Student = () => {
//   const [students, setStudents] = useState([]);
//   const [statusFilter, setStatusFilter] = useState('');
//   const [dateRange, setDateRange] = useState({ start: '', end: '' });
//   const [loading, setLoading] = useState(false);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     async function getCourses() {
//       try {
//         const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
//         if (response) {
//           console.log('students', response);
//           setStudents(response.data);
//         } else {
//           console.log('pull fail');
//         }
//       } catch (e) {
//         console.log('catch error', e);
//       }
//     }
//     getCourses();
//   }, []);

//   const fetchAttachments = async (userId) => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_BASEURL}/images`, {
//         params: { UserID: userId }
//       });
//       if (response) {
//         console.log('pulled', response);
//         setSelectedFiles(response.data);
//         setIsModalOpen(true);
//       } else {
//         console.log('pull fail');
//       }
//     } catch (e) {
//       console.log('catch error', e);
//     }
//   };

//   const handleStatusChange = async (index, student, newStatus) => {
//     const confirmed = window.confirm(`Do you want to update the status to ${newStatus}?`);
//     if (confirmed) {
//       setLoading(true);
//       const updatedStudents = [...students];
//       updatedStudents[index].ReviewStatus = newStatus;
//       try {
//         await axios.post(process.env.REACT_APP_BASEURL + '/api/application/update', {
//           User_ID: student.User_ID,
//           IndexID: student.IndexID,
//           ReviewStatus: newStatus,
//           FirstName: student.FirstName,
//           CourseName: student.CourseName,
//           Cost: student.Cost,
//           Email: student?.Email,
//           StartDate: student?.StartDate,

//           // <td>{student.FirstName}</td>
//           // <td>{student.LastName}</td>
//           // <td>{student.Phone}</td>
//           // <td>{student.Email}</td>
//           // <td>{student.CourseName}</td>
//         });
//         setStudents(updatedStudents);
//       } catch (error) {
//         alert(error.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleFilterChange = (e) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange((prev) => ({ ...prev, [name]: value }));
//   };

//   const filteredStudents = students
//     .filter((student) => {
//       const statusMatch = statusFilter ? student.ReviewStatus === statusFilter : true;
//       const dateMatch =
//         (!dateRange.start || new Date(student.CreationDate) >= new Date(dateRange.start)) &&
//         (!dateRange.end || new Date(student.CreationDate) <= new Date(dateRange.end));
//       return statusMatch && dateMatch;
//     })
//     .sort((a, b) => new Date(b.CreationDate) - new Date(a.CreationDate)); // Sort dates in descending order

//   return (
//     <div className="studentContainer">
//       <div className="header">
//         <h2>Student List</h2>
//         <div className="filters">
//           <select value={statusFilter} onChange={handleFilterChange} className="filterDropdown">
//             <option value="">All Statuses</option>
//             <option value="Pending">Pending</option>
//             <option value="Accepted">Accepted</option>
//             <option value="Rejected">Rejected</option>
//           </select>
//           <input
//             type="date"
//             name="start"
//             value={dateRange.start}
//             onChange={handleDateChange}
//             className="filterDate"
//           />
//           <input
//             type="date"
//             name="end"
//             value={dateRange.end}
//             onChange={handleDateChange}
//             className="filterDate"
//           />
//         </div>
//       </div>
//       {loading && <p>Loading...</p>}
//       <table className="studentTable">
//         <thead>
//           <tr>
//             <th>First Name</th>
//             <th>Last Name</th>
//             <th>Phone</th>
//             <th>Email</th>
//             <th>Registration</th>
//             <th>Course</th>
//             <th>Applied</th>
//             <th>Attachments</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredStudents.map((student, index) => (
//             <tr key={student.IndexID}>
//               <td>{student.FirstName}</td>
//               <td>{student.LastName}</td>
//               <td>{student.Phone}</td>
//               <td>{student.Email}</td>
//               <td>{student?.Status}</td>
//               <td>{student.CourseName}</td>
//               {/* <td>{String(student.CreationDate).substring(0, 10)}</td> */}
//               <td>{moment(student?.CreationDate).format('YYYY-MM-DD')}</td>
              
//               <td>
//                 <button onClick={() => fetchAttachments(student.User_ID)}>
//                   View Attachments
//                 </button>
//               </td>
//               <td>
//                 <select
//                   defaultValue={student.ReviewStatus}
//                   onChange={(e) => handleStatusChange(index, student, e.target.value)}
//                   className="statusDropdown"
//                 >
//                   <option value="Pending">Pending</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="Rejected">Rejected</option>
//                 </select>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <AttachmentsModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         files={selectedFiles}
//       />
//     </div>
//   );
// };

// export default Student;

//test

//BEFORE SORT
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// // import AttachmentsModal from './AttachmentsModal';
// import AttachmentsModal from '../AttachmentsModal/AttachmentsModal';
// import './Students.css';

// const Student = () => {
//   const [students, setStudents] = useState([]);
//   const [statusFilter, setStatusFilter] = useState('');
//   const [dateRange, setDateRange] = useState({ start: '', end: '' });
//   const [loading, setLoading] = useState(false);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     async function getCourses() {
//       try {
//         const response = await axios.get(process.env.REACT_APP_BASEURL + '/api/application/all');
//         if (response) {
//           console.log('students',response);
//           setStudents(response.data);
//         } else {
//           console.log('pull fail');
//         }
//       } catch (e) {
//         console.log('catch error', e);
//       }
//     }
//     getCourses();
//   }, []);


//   const fetchAttachments = async (userId) => {
//     try {
//         const response = await axios.get(`${process.env.REACT_APP_BASEURL}/images`, {
//             params: { UserID: userId }
//         });
//         if (response) {
//             console.log('pulled', response);
//             setSelectedFiles(response.data);
//             setIsModalOpen(true);
//         } else {
//             console.log('pull fail');
//         }
//     } catch (e) {
//         console.log('catch error', e);
//     }
// };


//   const handleStatusChange = async (index, student, newStatus) => {
//     const confirmed = window.confirm(`Do you want to update the status to ${newStatus}?`);
//     if (confirmed) {
//       setLoading(true);
//       const updatedStudents = [...students];
//       const studentz = updatedStudents[index];
//       studentz.ReviewStatus = newStatus;
//       try {
//         await axios.post(process.env.REACT_APP_BASEURL + '/api/application/update', {
//           User_ID: student.User_ID,
//           IndexID: student.IndexID,
//           ReviewStatus: student.ReviewStatus
//         });
//         setStudents(updatedStudents);
//       } catch (error) {
//         alert(error.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleFilterChange = (e) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange((prev) => ({ ...prev, [name]: value }));
//   };

//   const filteredStudents = students.filter((student) => {
//     const statusMatch = statusFilter ? student.Status === statusFilter : true;
//     const dateMatch =
//       (!dateRange.start || new Date(student.date) >= new Date(dateRange.start)) &&
//       (!dateRange.end || new Date(student.date) <= new Date(dateRange.end));
//     return statusMatch && dateMatch;
//   });

//   return (
//     <div className="studentContainer">
//       <div className="header">
//         <h2>Student List</h2>
//         <div className="filters">
//           <select value={statusFilter} onChange={handleFilterChange} className="filterDropdown">
//             <option value="">All Statuses</option>
//             <option value="Pending">Pending</option>
//             <option value="Accepted">Accepted</option>
//             <option value="Rejected">Rejected</option>
//           </select>
//           <input
//             type="date"
//             name="start"
//             value={dateRange.start}
//             onChange={handleDateChange}
//             className="filterDate"
//           />
//           <input
//             type="date"
//             name="end"
//             value={dateRange.end}
//             onChange={handleDateChange}
//             className="filterDate"
//           />
//         </div>
//       </div>
//       {loading && <p>Loading...</p>}
//       <table className="studentTable">
//         <thead>
//           <tr>
//             <th>First Name</th>
//             <th>Last Name</th>
//             <th>Phone</th>
//             <th>Email</th>
//             <th>Course</th>
//             <th>Applied</th>
//             <th>Attachments</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredStudents.map((student, index) => (
//             <tr key={student.id}>
//               <td>{student.FirstName}</td>
//               <td>{student.LastName}</td>
//               <td>{student.Phone}</td>
//               <td>{student.Email}</td>
//               <td>{student.CourseName}</td>
//               <td>{String(student.CreationDate).substring(0, 10)}</td>
//               <td>
//                 <button onClick={() => fetchAttachments(student.User_ID)}>
//                   View Attachments
//                 </button>
//               </td>
//               <td>
//                 <select
//                   defaultValue={student.ReviewStatus}
//                   onChange={(e) => handleStatusChange(index, student, e.target.value)}
//                   className="statusDropdown"
//                 >
//                   <option value="Pending">Pending</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="Rejected">Rejected</option>
//                 </select>
//               </td>

//               {/* <td>
//                 <select
//                   defaultValue={student.ReviewStatus}
//                   onChange={(e) => handleStatusChange(index, student, e.target.value)}
//                   className="statusDropdown"
//                 >
//                   <option value="Pending">Pending</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="Rejected">Rejected</option>
//                 </select>
//               </td> */}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <AttachmentsModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         files={selectedFiles}
//       />
//     </div>
//   );
// };

// export default Student;

// import React, { useState, useEffect } from 'react';

// import './Students.css';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';

// const Student = () => {
//   const [students, setStudents] = useState([]);
//   const [statusFilter, setStatusFilter] = useState('');
//   const [dateRange, setDateRange] = useState({ start: '', end: '' });
//   const [loading, setLoading] = useState(false);
//   const [Files, setFiles] = useState();


//   useEffect(()=>{

        
//     console.log("HI") 
//     console.log(process.env.REACT_APP_BASEURL+'/api/application/all') 
    
//    async function getCourses (){ 
        
//       try{      

//         const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/application/all')


//         console.log("am in useffect")

//         // if (courses){

//           if(response){ 

//               console.log("Courses",response.data)
//               setStudents(response?.data);

//           } else{
          
//             console.log("pull fail")
//           }
         
//         // }

//       }catch(e){
  
//             // console.log("catch error",e)
//       }
         

//    }
   
//     //  Async response = axios.get('http://localhost:8800/Books')

//     getCourses()
     

// },[])

// ///Get attachemets
// useEffect(() => {



//   async function getCourses() { 
//       try {      
//           const response = await axios.get(process.env.REACT_APP_BASEURL+'/images', {
//               params: {
//                   UserID: '2403000005' // Replace 'yourUserId' with the actual user ID you want to pass
//               }
//           });

//           console.log("am in useEffect")

//           if (response) { 
//               console.log("setFiles", response.data)
//               setFiles(response?.data);
//           } else {
//               console.log("pull fail")
//           }

//       } catch (e) {
//           console.log("catch error", e)
//       }
//   }

//   getCourses()
// }, [])












//   const handleStatusChange = async (index,student,newStatus) => {
//     const confirmed = window.confirm(`Do you want to update the status to ${newStatus}?`);

//     if (confirmed) {
//       setLoading(true);
//       const updatedStudents = [...students];
//       const studentz = updatedStudents[index];
//       studentz.ReviewStatus = newStatus;

//       try {
//         const response = await fetch(process.env.REACT_APP_BASEURL+"/api/application/update",{ 
 
//           method : "POST",
//           headers: { 
//           "content-type" : "application/json",
//           'Access-Control-Allow-Credentials': true
//           }, 

//           //  credentials: 'include'
//           //  ,
//           body: JSON.stringify({
//           // name,
//           // email,
//           // password,
//           // AccNo,
//           // Branch, 
//           User_ID : student.User_ID,
//           IndexID : student.IndexID,
//           ReviewStatus : student.ReviewStatus

//           }),
          

          
          

//           }) 

//     const data = await response.json();
//     // console.log(data);

   
//     if(data.status == 'Ok'){
//     // navigate("/login");
//    // navigate("/Home");
//     // setLoading(false);
//     // setErrMsg(false)
//     // setSuccessMsg(true)
//     // setMsg(data.msg)
    
//     // handleAuthForm()
//     }else{
//     // alert("Operation Failed")
//     // setLoading(false);
//     // setMsg(data.msg)
//     // setErrorMsg(true);
//     }
//         // const response = await fetch(`https://api.example.com/students/${student.id}`, {
//         //   method: 'PUT',
//         //   headers: {
//         //     'Content-Type': 'application/json',
//         //   },
//         //   body: JSON.stringify({ status: newStatus }),
//         // });

//         // if (response.ok) {
//         //   setStudents(updatedStudents);
//         //   alert('Status updated successfully!');
//         // } else {
//         //   throw new Error('Failed to update status');
//         // }
//       } catch (error) {
//         alert(error.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleFilterChange = (e) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange((prev) => ({ ...prev, [name]: value }));
//   };

//   const filteredStudents = students.filter((student) => {
//     const statusMatch = statusFilter ? student.Status === statusFilter : true;
//     const dateMatch =
//       (!dateRange.start || new Date(student.date) >= new Date(dateRange.start)) &&
//       (!dateRange.end || new Date(student.date) <= new Date(dateRange.end));
//     return statusMatch && dateMatch;
//   });

//   return (
//     <div className='studentContainer'>
//       <div className='header'>
//         <h2>Student List</h2>
//         <div className='filters'>
//           <select value={statusFilter} onChange={handleFilterChange} className='filterDropdown'>
//             <option value=''>All Statuses</option>
//             <option value='Pending'>Pending</option>
//             <option value='Accepted'>Accepted</option>
//             <option value='Rejected'>Rejected</option>
//           </select>
//           <input
//             type='date'
//             name='start'
//             value={dateRange.start}
//             onChange={handleDateChange}
//             className='filterDate'
//           />
//           <input
//             type='date'
//             name='end'
//             value={dateRange.end}
//             onChange={handleDateChange}
//             className='filterDate'
//           />
//         </div>
//       </div>
//       {loading && <p>Loading...</p>}
//       <table className='studentTable'>
//         <thead>
//           <tr>
//             <th>First Name</th>
//             <th>Last Name</th>
//             <th>Phone</th>
//             <th>Email</th>
//             <th>Course</th>
//             <th>Applied</th>
            
//             <th>Attachments</th>
//             <th>Status</th>
            
//           </tr>
//         </thead>
//         <tbody>
//           {filteredStudents.map((student, index) => (
//             <tr key={student.id}>
//               <td>{student.FirstName}</td>
//               <td>{student.LastName}</td>
//               <td>{student.Phone}</td>
//               <td>{student.Email}</td>
//               <td>{student.CourseName}</td>
//               <td>{String(student.CreationDate).substring(0,10)}</td>
//               <td>{"Attachments"}</td>
//               <td>
//                 <select
//                   defaultValue={student.ReviewStatus}
//                   onChange={(e) => handleStatusChange(index,student, e.target.value)}
//                   className='statusDropdown'
//                 >
//                   <option value='Pending'>Pending</option>
//                   <option value='Accepted'>Accepted</option>
//                   <option value='Rejected'>Rejected</option>
//                 </select>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default Student;
